import { IconButton, SvgIcon } from '@mui/material'
import React from 'react'

const FormatButton = ({ icon, onClick, isActive, disabled }) => (
  <IconButton
    sx={{
      borderRadius: 1,
      color: isActive ? '#3f51b5' : '#1F3D7C',
      backgroundColor: isActive ? 'rgba(63, 81, 181, 0.1)' : 'transparent',
    }}
    onMouseDown={(e) => {
      e.preventDefault()
      onClick()
    }}
    disabled={disabled}
  >
    <SvgIcon component={icon} sx={{ color: '#1F3D7C' }} fontSize="small" />
  </IconButton>
)

export default FormatButton
